import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Fabric } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { Kunde, KundeFilter } from 'api/kunde';
import { KundeSearch } from 'components/Kunde/KundeSearch';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { Helmet } from 'react-helmet';
import { KundeKarte } from 'components/Kunde/KundeKarte';

const styles = mergeStyleSets({
    container: {
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '300px 1fr',
        gridColumnGap: 15,
    },
    pivotItem: {
        height: 'calc(100vh - 75px)',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

interface KundeViewParams {
    kundeNr?: string;
}

export const KarteView: React.FC = () => {
    const { kundeNr } = useParams<KundeViewParams>();
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);

    const [kundeFilter, setKundeFilter] = React.useState<KundeFilter>({});
    const [selectedKunde, setSelectedKunde] = React.useState<Kunde | null>(null);

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Helmet>
                <title>Karte</title>
            </Helmet>
            <KundeSearch
                kundeNr={kundeNr ? parseInt(kundeNr, 10) : null}
                onChangeKundeFilter={(newKundeFilter) => setKundeFilter(newKundeFilter)}
                onSelectKunde={(kunde: Kunde) => setSelectedKunde(kunde)}
            />
            <KundeKarte
                kundeFilter={kundeFilter}
                selectedKunde={selectedKunde}
                onSelectKunde={(kunde: Kunde | null) => setSelectedKunde(kunde)}
            />
        </Fabric>
    );
};
